import React from 'react';
import {
    Box,
    Container,
    Grid,
    Typography,
    Divider,
} from '@mui/material';
import { AppList } from '../components/widgets/AppList';

const sections = {
    company: {
        title: 'Company',
        items: [
            { label: 'About Us', href: '/about' },
            { label: 'Careers', href: '/careers' },
            { label: 'Contact', href: '/contact' },
            { label: 'Blog', href: '/blog' }
        ]
    },
    services: {
        title: 'Services',
        items: [
            { label: 'Logistics Solutions', href: '/services/logistics' },
            { label: 'Warehousing', href: '/services/warehousing' },
            { label: 'Transportation', href: '/services/transportation' }
        ]
    },
    resources: {
        title: 'Resources',
        items: [
            { label: 'Documentation', href: '/docs' },
            { label: 'API Reference', href: '/api' },
            { label: 'Case Studies', href: '/case-studies' },
            { label: 'FAQs', href: '/faqs' }
        ]
    },
    legal: {
        title: 'Legal',
        items: [
            { label: 'Privacy Policy', href: '/privacy' },
            { label: 'Terms of Service', href: '/terms' },
            { label: 'Cookie Policy', href: '/cookies' },
            { label: 'Compliance', href: '/compliance' }
        ]
    }
};

const FooterPage = () => {

    const handleLinkClick = (item) => {
        if (item.href) {
            window.location.href = item.href;
        }
    };

    return (
        <Box
            component="footer"
            sx={{
                bgcolor: 'primary.main',
                color: 'primary.contrastText',
                py: 6,
                mt: 'auto'
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4} justifyContent="space-evenly">
                    {Object.entries(sections).map(([key, section]) => (
                        <Grid item xs={12} sm={6} md={3} key={key}>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    fontWeight: 'bold',
                                }}
                            >
                                {section.title}
                            </Typography>
                            <AppList
                                items={section.items}
                                onItemClick={handleLinkClick}
                                sx={{
                                    '& .MuiListItem-root': {
                                        p: 0,
                                        mb: 1
                                    },
                                    '& .MuiTypography-root': {
                                        color: 'primary.contrastText',
                                        opacity: 0.8,
                                        '&:hover': {
                                            opacity: 1
                                        }
                                    }
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>

                <Divider sx={{ my: 4, borderColor: 'primary.contrastText', opacity: 0.2 }} />

                <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                    <Grid item>
                        <Typography variant="body2" sx={{ opacity: 0.8 }}>
                            © {new Date().getFullYear()} Avis Logistics. All rights reserved.
                        </Typography>
                    </Grid>
                    <Grid item>
                        <AppList
                            items={[
                                { label: 'Language', href: '/language' },
                                { label: 'Settings', href: '/settings' }
                            ]}
                            sx={{
                                display: 'flex',
                                '& .MuiListItem-root': {
                                    width: 'auto',
                                    mr: 2,
                                    '&:last-child': {
                                        mr: 0
                                    }
                                },
                                '& .MuiTypography-root': {
                                    color: 'primary.contrastText',
                                    opacity: 0.8,
                                    '&:hover': {
                                        opacity: 1
                                    }
                                }
                            }}
                            onItemClick={handleLinkClick}
                        />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export { FooterPage };